import * as React from 'react';
import {FeedItem} from '../types'
import * as moment from 'moment';

export type FeedListRowProps = {
  item:FeedItem,
  onDelete:() => void
  onSync:() => void
}

declare var I18n : {
  locale: string,
  t: (_:string, __?: any) => string,
  toCurrency:(_:number) => string
}

export const FeedListRow = (props:FeedListRowProps) => (
  <tr>
    <td>{props.item.feed.name}</td>
    <td title={props.item.feed.url}>{props.item.feed.url}</td>
    <td>
      {props.item.status == "syncing" ?
        I18n.t("calendar_feeds.crud.syncing")
      : props.item.status == "error" ?
        <div className="error-message">{props.item.error}</div>
      : props.item.feed.last_synced_at != null ?
        I18n.t("calendar_feeds.crud.last_synced_at", { date: moment(props.item.feed.last_synced_at).format("L LT")})
      : I18n.t("calendar_feeds.crud.last_synced_at", { date: '-'})}
    </td>
    <td>
      <a href="#" onClick={(e) => { e.preventDefault(); props.onSync()}}>
         <i className={`icon icon-sync ${props.item.status == "syncing" ? 'icon-sync--rotate' : ''}`}></i>
      </a>
      <a href="#" onClick={(e) => { e.preventDefault(); props.onDelete() }}>
       <i className="icon icon-close"></i>
      </a>
    </td>
  </tr>
)
